/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { HiFolderRemove } from "react-icons/hi";
import { UploadsUrl } from "../../services/url";
const Link_Box1 = (props) => {
  return (
    <div className='d-flex justify-content-end'>
      <a href={props.link} className='link-box-1'>
        <div className='avatar'>
          <img src={`${UploadsUrl}/${props.avatar}`} alut='default-user' />
        </div>
        <div class='detail'>
          <h4>{props.name}</h4>
          <p>{props.job}</p>
          <div className='fileNumber'>
            <span>
              <HiFolderRemove size={23} />
            </span>
            <span>شماره پرونده</span>
            <span>{props.fileNumber}</span>
          </div>
        </div>
      </a>
    </div>
  );
};
export default Link_Box1;
